"use strict";
function extractCharCode(str) {
  return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}
exports.extractCharCode = extractCharCode;
//# sourceMappingURL=extractCharCode.js.map
